
export const replaceNameTag = (
    text: string,
    isLoggedIn: boolean,
    firstName: string | undefined
): string => {
    if (isLoggedIn && firstName) {
        return text.replace(/\[name]/g, firstName);
    }

    return text;
};
